import { Auth } from "components/Parts/Organisms/Auth";
import { CheckEstatesPage } from "components/Parts/Organisms/CheckEstatesPage";
import React from "react";

export const CheckEstates = React.memo((props: { ownDraft: boolean }) => (
  <Auth>
    <CheckEstatesPage ownDraft={props.ownDraft} />
  </Auth>
));
